// extracted by mini-css-extract-plugin
export default {"chip":"style_chip__1jFZX","extern":"style_extern__xrz2t","intern":"style_intern__k9k+K"};